module.exports = __webpack_public_path__ + "img/new_2.f818505e.png";